const lab = () => {
    $(document).ready(function () {
        if ($(".labs").length) {
            var $slider = $('[data-slider]');
            var $counter = $('.slider-counter');

            $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $counter.text(i + ' / ' + slick.slideCount);
            });

            $slider.slick({
                slidesToShow: 1,
            });
        }
    });
}

module.exports = lab;
